<template>
<div>
  <pageLogin
     v-if="page === 'login'"
     @loginPage="signIn" 
     @register="register"
     @googleLogin="googleLogin"
     :error_register="error_register" 
     :error_login="error_login"
  ></pageLogin>
<dashboard
      v-else-if="page === 'dashboard'" 
      :tasks="tasks" 
      @create-new-todo="createNewTodo" 
      @edit-todo="editTodo"
      @delete-task="deleteTask"
      @logout="logout"
      @on-drop="onDrop"
      @start-drag="startDrag"
      ref="dashboard"
></dashboard>
  </div>
</template>

<script>
import pageLogin from './views/login-page.vue'
import dashboard from './views/Dashboard.vue'
import axios from 'axios'
const baseUrl = 'https://still-scrubland-80706.herokuapp.com/'
// const baseUrl = 'http://localhost:3000/'

export default {
    name: "App",
    components: { dashboard, pageLogin },
    data() {
        return {
            page: 'login',
            error_login : [],
            error_register : [],
            tasks: [],
        }
    },
    methods: {
         signIn(data) {
           console.log(data);
           axios({
            method: 'POST',
            url: baseUrl + 'login',
            data: { 
                email: data.email,
                password: data.password            }
             })
        .then(({data}) => {
            console.log(data, '<<<< ini daari axios');
            localStorage.access_token = data.access_token;
            localStorage.id = data.id;
            localStorage.email = data.email;
            localStorage.name = data.name;
            this.checker()
            this.fetch_tasks()

        })
        .catch(err => {
        console.log(err);
            this.error_login = err.response.data.message
        })
    },
    register(data){
        // console.log(data, '<<<<< ini di axios register atas');
      axios({
          method: 'POST',
          url: baseUrl + 'register',
        //   data: {
            
        //       email: data.email,
        //     password: data.password
        //   }
        data:data
        })
        .then( datas => {
          let loginData = {
            email: datas.data.User.email,
            password: data.password
          }
        // console.log(datas, '<<<< ini di axios');
          this.signIn(loginData)
        })
        .catch(err =>{
        //   console.log(err)
        this.error_register = err.response.data.errors
        })
    },
    fetch_tasks() {
        axios({
            method: 'GET',
            url: baseUrl + 'tasks',
            headers: {
                access_token: localStorage.getItem('access_token')
            }
        })
        .then( data => {
            this.tasks = data
        })
        .catch( err => {
            // console.log(err);
        })
    },
    checker() {
        if(localStorage.getItem('access_token')) {
            this.page = 'dashboard'
        } else {
            this.page = 'login'
        }
    },

    createNewTodo(data) {
        axios({
            method: 'POST',
            url: baseUrl + 'tasks',
            headers: {
                access_token: localStorage.getItem('access_token')
            },
            data: {
                title: data.title,
                category: data.category
            },

        })
        .then( data => {
            this.fetch_tasks()
        })
        .catch(err => {
            // console.log(err);
            let errors = err.response.data.errors
            this.$refs.dashboard.showModalError()
        })
    },
    editTodo(data){
        let reqData = {}
        if (data.title) {
            reqData.title = data.title
        }
        if (data.category) {
            reqData.category = data.category
        }
        axios({
            method: 'PATCH',
            url: baseUrl+'tasks/'+data.id,
            headers: {
                access_token: localStorage.getItem('access_token')
            },
            data: reqData,
        })
        .then( data => {
            this.fetch_tasks()
        })
        .catch(err => {
            // console.log(err);
            let errors = err.response.data.errors
            this.$refs.dashboard.showModalError()
        })
    },
    deleteTask(id){
        axios({
            method: 'DELETE',
            url: baseUrl + 'tasks/'+id,
            headers: {
                access_token: localStorage.getItem('access_token')
            },
        })
        .then( data => {
            this.fetch_tasks()
        })
        .catch( err => {
            // console.log(err);
            let errors = err.response.data.errors
            this.$refs.dashboard.showModalError()
        })
    },
    logout() {
        localStorage.clear()
        this.checker()
    },
    startDrag: (ev, item) => {
        // console.log(item, 'item');
        // console.log(ev);
        ev.dataTransfer.dropEffect = 'move'
        ev.dataTransfer.effectAllowed = 'move'
        ev.dataTransfer.setData('items', JSON.stringify(item))
    },

    onDrop(ev, category) {
        const data = JSON.parse(ev.dataTransfer.getData('items'))
        // console.log(data,'data');
        let reqData = {
            category: category,
            id: data.id
        }
        this.editTodo(reqData)
    },
    googleLogin(data) {
        axios({
            method: 'POST',
            url: baseUrl + 'login/googleLogin',
            data: {
                id_token: data.getAuthResponse().id_token,
                email: data.email,
                password: data.password
            }
        })
        .then(({data}) => {
            console.log(data, '<<<< ini daari axios');
            localStorage.access_token = data.access_token;
            localStorage.id = data.id;
            localStorage.email = data.email;
            localStorage.name = data.name;
            this.checker()
            this.fetch_tasks()

        })
        .catch(err => {
            // console.log(err);
            this.error_login = err.response.data.errors
        })
      }
    },
        computed: {
         register_errors: function() {
             return this.error_register
           },
        },
        created() {
         this.checker()
        },
        mounted() {
        this.checker()
         this.fetch_tasks()
        }
}

</script>

<style scoped>

</style>